import InvokeFields from "../util/InvokeFields";
import { getGlobal } from 'reactn';
import Constants from "../util/Constants";

export default class TwitterDataAccess {

    public static TWITTER = "Twitter";

    public static TWITTER_LIKES = "favoriteCount";
    public static TWITTER_RETWEET = "retweetCount";

    public data:Array<TwitterModel> = [];

    public async fetchData(dataSourceId:string, timeInterval:TimeInterval):Promise<any> {
        var self = this;
        return new Promise(async function(resolve, reject) {
            let input:TwitterInput = {
                field:InvokeFields.getTwitterDataset,
                dataSourceId:dataSourceId
            }
            //self.data = await getGlobal().data.getTwitter(input);
            self.data = await getGlobal().dataManager.get("getTwitter", input);
            console.log(self.data);
            resolve(self.data);
        });
    }

    public clearData() {
        this.data = [];
    }

    public static getMetricOptions() {
        return [TwitterDataAccess.TWITTER_LIKES, TwitterDataAccess.TWITTER_RETWEET];
    }

    public static getXAxisOptions() {
        return [Constants.AXIS_DATE, "deviceType"];
    }
}